'use client';

import WishlistSVG from '~/assets/svg/icons/wishlist';
import { Book, ProductViewSource } from 'types';

import useAuthenticatedAction from '~/lib/hooks/use-authenticated-action';
import useShelves from '~/lib/hooks/use-shelves';
import Button from '../button';
import SessionForm from '../session-form';

interface WishlistButtonProps {
  book: Book;
  source: ProductViewSource;
  disabled?: boolean;
  type?: 'book' | 'title';
}

export default function WishlistButton(props: WishlistButtonProps) {
  const { handleShelf, isTitleInShelf, isBookInShelf } = useShelves({ source: props.source });

  const IN_SHELF =
    props.type === 'title'
      ? isTitleInShelf(props.book.title_id)
      : isBookInShelf(props.book);

  const { handleAuthAction } = useAuthenticatedAction({
    actionToCall: () => handleShelf({ book: props.book, type: props.type }),
  });

  async function handleLikeClick(e) {
    e.preventDefault();

    await handleAuthAction({
      title: 'Login to add to your Shelves',
      message:
        'You need an account to favorite this book, please sign in with one of the methods below.',
      component: <SessionForm />,
    });
  }

  function getFillColor() {
    let fillColor: string;

    if (props.disabled) {
      fillColor = 'var(--lightGrey)';
    } else if (IN_SHELF) {
      fillColor = 'var(--primary)';
    }

    return fillColor;
  }

  function getStrokeColor() {
    let strokeColor: string;

    if (props.disabled) {
      strokeColor = 'var(--lightGrey)';
    } else if (IN_SHELF) {
      strokeColor = 'var(--primary)';
    } else {
      strokeColor = 'var(--copyDark)';
    }

    return strokeColor;
  }

  return (
    <Button
      style='outline'
      shape='circle'
      icon={
        <WishlistSVG
          fillColor={getFillColor()}
          strokeColor={getStrokeColor()}
        />
      }
      onPress={handleLikeClick}
      disabled={props.disabled}
    />
  );
}
